import Skeleton from "./Skeleton";
import { fadeDownOpacity } from "./skeleton.utils";
import styles from "./Skeleton.module.scss";

type Props = {
  count?: number;
  cardHeight?: number;
  minCardWidth?: number;
  className?: string;
};

const SkeletonGrid = ({
  count = 8,
  cardHeight = 220,
  minCardWidth = 260,
  className = "",
}: Props) => (
  <div
    className={`${styles.grid} ${className}`}
    style={{ gridTemplateColumns: `repeat(auto-fill, minmax(min(${minCardWidth}px, 100%), 1fr))` }}
  >
    {Array.from({ length: count }, (_, index) => (
      <Skeleton
        key={index}
        height={cardHeight}
        radius={12}
        style={{ opacity: fadeDownOpacity(index) }}
      />
    ))}
  </div>
);

export default SkeletonGrid;
